import React from 'react';
import AxesPart from './ChartCreationParts/AxesPart';
import ChartTypePart from './ChartCreationParts/ChartTypePart';
import DataPart from './ChartCreationParts/DataPart';
import {Flex} from '@priority-software/priority-style-react';
import styles from '../styles.module.scss';

interface ChartCreationSelectorProps {
    currentChartTab: string;
}

const tabComponents = {
    '0': <ChartTypePart />,
    '1': <DataPart />,
    '2': <AxesPart />
};

const ChartCreationSelector: React.FC<ChartCreationSelectorProps> = ({
    currentChartTab = '0'
}: ChartCreationSelectorProps) => {
    return (
        <Flex
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            componentClasses={styles.chartContent}
        >
            {tabComponents[currentChartTab]}
        </Flex>
    );
};

export default ChartCreationSelector;
